"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.history.empty': '暂无活动',
};
